interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

const HomepageBannerCTAValues = {
    control: 'search',
    base: 'city_browse',
};

export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'banner_cta_opens_search_screen',
    paramName: 'banner_cta_destination',
    values: HomepageBannerCTAValues,
};

/**
 * Leave the names of the enums/configs/etc static to keep imports from
 * needing to change as we iterate.
 *
 * Update the values to represent the new focus/paramname/goal of the test.
 * At the moment these correlate to the card map exported from DiscoverEventCard.
 */
export enum SearchCardMobileExperimentValues {
    control = 'control',
    verticalA = 'verticalA',
    verticalB = 'verticalB',
    // Until we do additional testing on
    // content within the card commenting out
    // other variants.
}

export enum SearchCardDesktopExperimentValues {
    control = 'control',
    variant = 'variant',
}

export enum SearchCardMobileExperimentConfig {
    name = 'search_event_card_mobile_v2',
    paramName = 'search_card_type',
}

export enum SearchCardDesktopExperimentConfig {
    name = 'search_event_card_desktop_v2',
    paramName = 'search_card_type',
}

export const SearchCardMobileExperiment: Experiment<
    typeof SearchCardMobileExperimentValues
> = {
    name: SearchCardMobileExperimentConfig.name,
    paramName: SearchCardMobileExperimentConfig.paramName,
    values: SearchCardMobileExperimentValues,
};

export const SearchCardDesktopExperiment: Experiment<
    typeof SearchCardDesktopExperimentValues
> = {
    name: SearchCardDesktopExperimentConfig.name,
    paramName: SearchCardDesktopExperimentConfig.paramName,
    values: SearchCardDesktopExperimentValues,
};

export interface SearchServerEnrolledExperiments {
    [SearchCardMobileExperimentConfig.name]?: {
        [SearchCardMobileExperimentConfig.paramName]: SearchCardMobileExperimentValues;
    };
    [SearchCardDesktopExperimentConfig.name]?: {
        [SearchCardDesktopExperimentConfig.paramName]: SearchCardDesktopExperimentValues;
    };
}
